import { type WrappedInsight } from "@clipboard-health/contract-worker-app-bff";
import { useCallback, useState } from "react";

interface UseInsightsNavigationProps {
  insights: WrappedInsight[];
}

interface UseInsightsNavigationReturn {
  currentIndex: number;
  currentInsight: WrappedInsight | undefined;
  lastIndex: number;
  isFirst: boolean;
  isLast: boolean;
  goNext: () => void;
  goPrevious: () => void;
}

export function useInsightsNavigation(
  props: UseInsightsNavigationProps
): UseInsightsNavigationReturn {
  const { insights } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentInsight = insights[currentIndex - 1];
  const isFirst = currentIndex === 0;
  const lastIndex = insights.length + 1;
  const isLast = currentIndex === lastIndex;

  const goNext = useCallback(() => {
    setCurrentIndex((previous) => {
      return previous + 1;
    });
  }, []);

  const goPrevious = useCallback(() => {
    setCurrentIndex((previous) => {
      return previous - 1;
    });
  }, []);

  return {
    currentIndex,
    currentInsight,
    lastIndex,
    isFirst,
    isLast,
    goNext,
    goPrevious,
  };
}
